<template>
  <label class="ulabel" :class="{'ulabel_arrow':arrow, 'active':active, 'filled':filled}">
    <span class="ulabel__placeholder" v-if="placeholder">{{placeholder}}</span>
    <svg v-if="arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M7 9.5L12 14.5L17 9.5" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
    <slot/>
    <div v-if="error" class="ulabel__error">{{error}}</div>
  </label>
</template>

<script>
  export default {
    props: {
      placeholder: {type: String, default: ''},
      arrow: {type: Boolean, default: false},
      active: {type: Boolean, default: false},
      filled: {type: Boolean, default: false},
      error: {type: String, default: ''},
    }
  }
</script>

<style lang="sass">
.ulabel
  position: relative
  z-index: 1
  height: 63px
  width: 100%
  max-width: 100%
  display: flex
  flex-direction: column
  justify-content: flex-end
  &_zindex
    z-index: 2
  &_arrow
    svg
      transform-origin: center 23.5%
      position: absolute
      right: 16px
      top: 50%
      transform: translateY(-50%)
      transition: .1s ease-out
      @include for-mob
        right: 10px

  &_arrow &__input
    padding-right: 40px
  &__input
    border: none
    margin-bottom: 2px
    outline: none
    letter-spacing: 0.01em
    font-size: 16px
    line-height: 1.12
    color: colors.$gray3
    padding: 16px
    color: black
    transition: border-color .1s ease-out
    border-bottom: 1px solid colors.$moar_silver_for_the_god_of_silver
    @include for-mob
      padding: 16px 10px
    &[type]
      padding: 16px 16px 4px
      @include for-mob
        padding: 16px 10px 4px

  &__placeholder
    letter-spacing: 0.01em
    font-size: 16px
    line-height: 1.12
    position: absolute
    transform-origin: left top
    color: colors.$newgray
    bottom: 19px
    left: 16px
    transition: .3s ease-out
    @include for-mob
      left: 10px
  &:focus-within &__placeholder, &.filled &__placeholder
    transform: translateY(-13px) scale(.75)
    @include for-mob
      transform: translateY(-4px) scale(.75)
  &.active svg
    transform: rotateX(180deg)
  &.filled &__input, &:focus-within &__input, &__input:focus
    margin-bottom: 1px
    border-bottom: 2px solid colors.$newgray
  @include for-mob
    &__input, &__placeholder
      font-size: 16px
  &__error
    font-size: 12px
    font-weight: 500
    position: absolute
    top: calc(100% + 3px)
    left: 16px
    color: colors.$newred
    @include for-mob
      left: 10px
</style>